import { render, staticRenderFns } from "./analyses.vue?vue&type=template&id=66f3ca9f&"
import script from "./analyses.ts?vue&type=script&lang=ts&"
export * from "./analyses.ts?vue&type=script&lang=ts&"
import style0 from "./analyses.vue?vue&type=style&index=0&id=66f3ca9f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports